module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container p-0"
  }, [_c('b-card', {
    attrs: {
      "no-body": "",
      "header-text-variant": "dark"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('context-header', {
    attrs: {
      "title": _vm.$t('invoices.invoiceReview'),
      "tab": _vm.namedTab
    }
  })], 1), _vm._v(" "), _c('b-tabs', {
    ref: "tabs",
    staticClass: "test-class",
    attrs: {
      "card": "",
      "lazy": "",
      "pills": "",
      "variant": "danger"
    },
    on: {
      "input": function($event) {
        return _vm.tabChanged()
      }
    },
    model: {
      value: (_vm.tabIndex),
      callback: function($$v) {
        _vm.tabIndex = $$v
      },
      expression: "tabIndex"
    }
  }, [(!_vm.isAdmin) ? _c('b-tab', {
    attrs: {
      "title": _vm.headers[0].title
    }
  }, [_c('creditor-invoices')], 1) : _vm._e(), _vm._v(" "), (!_vm.isAdmin) ? _c('b-tab', {
    attrs: {
      "title": _vm.headers[1].title
    }
  }, [_c('debtor-invoices')], 1) : _c('b-tab', {
    attrs: {
      "title": _vm.headers[2].title
    }
  }, [_c('admin-invoices')], 1)], 1)], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-c1a7d0b2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c1a7d0b2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href","b-img":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/invoices/Invoices.vue
// module id = 804
// module chunks = 1